import React from 'react'
import { FaWhatsapp  } from "react-icons/fa";

const ImageSilderContainer = () => {
  return (
    <div className='text-4xl relative'>
      <div className='fixed right-2 bottom-16 bg-black rounded-full text-white p-2 z-10'>
        <a href="https://wa.me/+32483001517" target='_blank' rel="noopener noreferrer"> <FaWhatsapp  /></a>
      </div>

    </div>
  )
}

export default ImageSilderContainer
